import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MetalRatesService {

  url = environment.serverAPI4 + "/api/metalRates";

  constructor(private http: HttpClient) { }


  getMetalRatesById(metalRateId: number): Observable<Object> {
    return this.http.get(`${this.url}/${metalRateId}`);
  }

}
